import { axiosApiClient } from "../index";

export const sendContactForm = async (contactData) => {
  try {
    const response = await axiosApiClient.post("/contact", contactData);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Greška prilikom slanja poruke"
    );
  }
};
